import { Side, front, top, right, bottom, left, back } from 'src/constants/sides'
import { Box3, Vector3 } from 'three'

export const getSideProperties = (
  side: Side,
  boundings: Box3,
  siblings?: {
    edges: {
      properties: { side: Side }
      node: {
        properties: {
          thickness: { value: number }
        }
      }
    }[]
  }
): { width: { value: number }; length: { value: number } } => {
  let width = 0,
    length = 0
  const sides: { [P in Side]: number } = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    front: 0,
    back: 0
  }
  siblings?.edges?.forEach(
    ({
      properties: { side },
      node: {
        properties: {
          thickness: { value }
        }
      }
    }) => (sides[side] += value)
  )
  const boundingsSize = new Vector3()
  boundings.getSize(boundingsSize)
  const { x: contentWidth, y: contentHeight, z: contentDepth } = boundingsSize
  switch (side) {
    case top:
    case bottom:
      width = contentDepth + sides.front + sides.back
      length = contentWidth + sides.left + sides.right
      break
    case right:
    case left:
      width = contentDepth + sides.front + sides.back
      length = contentHeight + sides.top + sides.bottom
      break
    case front:
    case back:
      width = contentWidth + sides.right + sides.left
      length = contentHeight + sides.top + sides.bottom
      break
    default:
      break
  }
  return { width: { value: width }, length: { value: length } }
}
